module.exports = __webpack_public_path__ + "public/SiteIcons/chat.png?c89773c7";